/* @flow strict */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';
import ReactSummernote from 'react-summernote';
import { SummenrNoteToolbar } from '/client/src/constants/';

type PropsType = {
  termsAndConditions: string,
  isSetTermsAndConditions: boolean,
  handleChangeInput: () => void,
  handleControlEventTerms: () => void
};

const Terms = ({
  termsAndConditions,
  isSetTermsAndConditions,
  handleChangeInput,
  handleControlEventTerms
}: PropsType): React.Element<typeof React.Element> => {
  return (
    <CollapsedPanel
      status={isSetTermsAndConditions}
      title='Edit terms and conditions'
      onChange={(status: boolean): any => handleControlEventTerms(status)}
    >
      <div className="form-group SimpleInput">
        <label htmlFor="eventUrl">Add terms and conditions</label>
        <React.Suspense>
          {navigator ?
            <div className='js-anchor-terms'>
              <ReactSummernote
                children={<div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />}
                options={{
                  lang: 'en-US',
                  height: 200,
                  dialogsInBody: true,
                  toolbar: SummenrNoteToolbar
                }}
                onInit={() => {
                  setTimeout(() => {
                    const resizebleEl = document.querySelector('.js-anchor-terms .note-editable.panel-body');

                    if (resizebleEl) {
                      resizebleEl.style.resize = 'vertical';
                    }
                  }, 1000);
                }}
                onChange={(content: string) => {
                  handleChangeInput({
                    target: {
                      name: 'terms_and_conditions',
                      value: content
                    }
                  });
                }}
              />
            </div> : null
          }
        </React.Suspense>
      </div>
    </CollapsedPanel>
  );
};

export default Terms;
